<template>
  <FriedModal :closable="false">
    <template #header>
      <FriedModalHeader :header="t('module_access_changed_title')" />
    </template>
    {{ t('module_access_changed_description') }}
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton data-external="module-access-changed-modal-button" @click="$emit('close')"
          >{{ t('qes_information_modal_button_text') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>
<script>
import { defineComponent } from 'vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  emits: ['close'],
  setup() {
    return { t };
  },
});
</script>
